import * as React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { withRouter } from 'react-router';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateToHTML } from 'draft-js-export-html';


class TextEditorComponent extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty()
        };

        this.handleBlurEvent = this.handleBlurEvent.bind(this);
    }

    onEditorStateChange = (editorState: any) => {
        this.setState({
            editorState
        });
    };

    componentDidMount() {
        if (this.props.htmlInput) {
            const blocksFromHTML = convertFromHTML(this.props.htmlInput);
            if (blocksFromHTML && blocksFromHTML.contentBlocks && blocksFromHTML.entityMap) {
                const state = ContentState.createFromBlockArray(
                    blocksFromHTML.contentBlocks,
                    blocksFromHTML.entityMap,
                );

                this.setState({ editorState: EditorState.createWithContent(state) });
            }
        }

    }

    handleBlurEvent() {
            this.updateHtmlFromEditor(stateToHTML(this.state.editorState.getCurrentContent()));
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
                if (this.props.htmlInput !== nextProps.htmlInput) {
            if (nextProps.htmlInput) {
                const blocksFromHTML = convertFromHTML(nextProps.htmlInput);
                if (blocksFromHTML && blocksFromHTML.contentBlocks && blocksFromHTML.entityMap) {
                    const state = ContentState.createFromBlockArray(
                        blocksFromHTML.contentBlocks,
                        blocksFromHTML.entityMap,
                    );

                    this.setState({ editorState: EditorState.createWithContent(state) });
                }
            } else {
                this.setState({ editorState: EditorState.createEmpty() });
            }
        }
    }

    updateHtmlFromEditor(htmlData: any) {
        this.props.updateHtmlFromEditor(htmlData);
    }

    render() {
        const { editorState } = this.state;
        return (
            <>
                <Editor
                    editorState={editorState}
                    wrapperClassName="text-editor-wrapper"
                    editorClassName="text-editor"
                    onEditorStateChange={this.onEditorStateChange}
                    onBlur={this.handleBlurEvent}
                    toolbar={{
                        options: ['inline', 'list', 'link'],
                        inline: {
                            options: ['bold', 'italic', 'underline',]
                        },
                        link: {
                            showOpenOptionOnHover: true,
                            defaultTargetOption: '_blank',
                            options: ['link', 'unlink'],
                            linkCallback: (event: any) => {
                                console.log('link created', event)
                                setTimeout(() => this.handleBlurEvent(), 500)
                                return event;
                            }
                        },
                    }}
                />
            </>
        )
    }
}

export default withRouter(TextEditorComponent);


// WEBPACK FOOTER //
// ./src/components/common/editor/TextEditorComponent.tsx